import { Box, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import style from "./Explore_2_1.module.css";
import MultiChoiceBtnGroup from "../../components/button_group/MultiChoiceBtnGroup";
import PageButton from "../../components/PageButton";
import { observer } from "mobx-react-lite";

function Explore_2_1() {
  return (
    <Box className={style.box}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} md={6} className={style.questionbox}>
          <Typography className={style.line} variant="h4">
            創業初期會面臨到的挑戰
          </Typography>

          <div className={style.TitleBox}>
            <Typography variant="h7" className={style.Title}>
              我想創業，目前遇到的挑戰是？
            </Typography>
            <Typography variant="h7" className={style.SubTitle}>
              &nbsp;(請選擇)
            </Typography>
          </div>

          <Grid xs={12} md={10} className={style.ChoiceBtn}>
            <MultiChoiceBtnGroup
              btnList={[
                "缺乏資金",
                "法規限制",
                "缺乏共同創辦人",
                "找不到市場",
                "競爭者",
                "缺乏可行的商模",
              ]}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <div>
            <Typography variant="h7" className={style.wordsbox}>
              &nbsp;&nbsp;&nbsp;&nbsp;
              根據〈2019台灣新創生態圈大調查〉新創開始創業時面臨最大的挑戰，創業初期關注募資與市場開發是必然的，但是這項調查結果顯示，新創企業高度關注市場開發與業務拓展時，卻僅有4％關注競爭者。
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              許多新創對於自己領先競爭者多少程度或時間沒有具體概念，顯示新創並不清楚自己所認定的產品或服務優勢，在市場上到底處於怎樣的位置或具備怎樣的價值。
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              說明創業者對「市場」的理解不夠全面，而若是往後對照新創企業營收不佳的原因，其中「相似產品或服務競爭者眾」高居第三，縣市創業者對於市場與競爭者的了解不足，對創業產品或點子的看法太過自我感覺良好，缺乏外界的刺激與及早修正，以致容易進學已成紅海競爭的市場。
              <br />
            </Typography>
          </div>
        </Grid>
      </Grid>
      <div className={style.pageBtn}>
        <PageButton passPath={"/explore-4"} nextPath={"/explore-2-2"} />
      </div>
    </Box>
  );
}

export default observer(Explore_2_1);
